import React, { useEffect } from 'react';
import { string } from 'prop-types';
import { revJetConfig } from './RevJetConfig';

export const RevJet = (props) => {

  const {
    itemId,
    envSpace,
    parentId,
  } = props;

  const revJetOnload = () => {
    if (window) {
      window.revjet = window.revjet || {};
      window.revjet.tags = window.revjet.tags || [];
      window.revjet.tags.push({
        _tag: revJetConfig[envSpace].tag,
        _plc_id: revJetConfig[envSpace].plc_id,
        _key: revJetConfig[envSpace].key,
        _opts: {
          embd_tag_id: (function (doc) {
            let tag = doc.createElement('div');
            tag.id = 'revjet-tag-' + window.revjet.tags.length;
            let scriptRevJet = doc.getElementById(parentId);
            scriptRevJet.prepend(tag);
            return tag.id;
          }(document)),
          responsive: true,
          autoscale: false,
          autohide: true,
          responsive_height: 'dynamic',
          delivery_method: 'banner',
          _imp_banner_size: '1400x1400',
        },
        omsid: itemId
      });
    }
  };

  useEffect(() => {
    const script = document.createElement('script');

    script.onload = () => revJetOnload();
    script.src = revJetConfig[envSpace].path;
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [itemId]);

  return (
    <div id={parentId} />
  );
};

RevJet.displayName = 'RevJet';

RevJet.propTypes = {
  itemId: string.isRequired,
  envSpace: string.isRequired,
  parentId: string.isRequired
};